export default __webpack_public_path__ + "static/media/Raion4.650bc58d.png";